<template>
  <div class="video-card" v-if="videoContents.length && mysmartcard">
    <div class="heading">
      <h2><span class="yellow">My</span> <span class="black">Videos</span></h2>
    </div>
    <div v-for="(video, index) in videoContents" :key="index">
      <YouTube :src="video.contentUrl" width="100%" height="100%" />
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import YouTube from "vue3-youtube";
import type { QwikUCard, SmartContent } from '@/types';

type Props = {
  mysmartcard: QwikUCard;
};

const props = defineProps<Props>();

const videoContents = computed((): SmartContent[] => {
  if (!props.mysmartcard?.SmartContent) {
    return [];
  }

  return props.mysmartcard.SmartContent.filter(
    (content) => content.contentType === "videoContent"
  );
});
</script>

<style src="@/assets/styles/shared-styles.css"></style>
